import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { TextInput, Button, Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow, 
  Loading
  // DataTable 
} from 'carbon-components-react';
// import Table
// import { Table } from 'carbon-components-react/lib/components/DataTable';
import MyModal from '../../components/Modal/Modal';
import { addStudy, getSingleCTGStudy, searchCTGStudy } from '../../api/studyListApi';

const headers = ['','Org Study ID', 'NCT ID', 'Sponsor', 'Has Owner?' ];

const NewStudyModal = ({
  open = false,
  refreshStudyList = () => {},
  onClose = () => {},
  loading,
}) => {
  const [org_study_id, setOrgStudyId] = useState("");
  // const [foundStudies, setFoundStudies] = useState([])
  const [selectedStudy, setSelectedStudy] = useState('')
  const [nonCtgStudyId, setNonCtgStudyId] = useState("");
  const [rows, setRows] = useState([])
  // const [loadingStudies, setLoadingStudies] = useState(false)

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const onChangeInput = (input) => {
    setOrgStudyId(input);
  };

  const onChangeInputNonCtg = (input) => {
    setNonCtgStudyId(input);
  };

  const searchStudy = () => {
    if(!org_study_id) {
      toaster("Study ID is required", "warning")
      return;
    }
    // setLoadingStudies(true)
    searchCTGStudy(org_study_id).then(res => {
      // setFoundStudies(res)
      if(res.length > 0){
        let rowData = []
        res.map(element => {
          rowData.push({
            id: element._id,
            org_study_id: element?._source?.ctg_data?.org_study_id,
            nct_id: element?._source?.ctg_data?.id_info?.nct_id,
            sponsor: element?._source?.ctg_data?.trial_sponsor_agency,
            hasOwner: element?._source?.tenant ? 'Yes' : 'No'
          })
        })
        setRows(rowData)
      }
      else if(res.length === 0){
        setRows([])
      }
    })
    // setLoadingStudies(false)
    // loading(true);

  }
  const createStudyCTG = () => {
    loading(true);
    onClose();
    addStudy(org_study_id, selectedStudy).then(res => {
      toaster("New study created successfully", "success")
      setOrgStudyId("");
      window.open(`studies/${res?.data?.uid}`,'_blank')
      setRows([])
      loading(false);
      setSelectedStudy('')
      refreshStudyList();
    }).catch(error => {
      toaster("Failed to create new study", "error")
      loading(false);
    });
  }
  const createStudyNonCTG = () => {
    if (!nonCtgStudyId) {
      toaster("Study ID is required", "warning")
      return;
    }
    loading(true);
    onClose();
    addStudy(nonCtgStudyId, 'none').then(res => {
      toaster("New study created successfully", "success")
      setOrgStudyId("");
      window.open(`${res.data.uid}`,'_blank')
      setRows([])
      loading(false);
      refreshStudyList();
    }).catch(error => {
      toaster("Failed to create new study", "error")
      loading(false);
    });
  }

  const refreshOrgStudyId = () =>{
   setOrgStudyId("");
    onClose();
  };

  return (
    <MyModal
      // modalHeading="Add New Study"
      size="lg"
      open={open}
      onRequestClose={refreshOrgStudyId}
    >
      <ModalContent>
        <div className=''>
          <ModalTitle>Create Non-CTG Study</ModalTitle>
          <InputContainer>
          <TextInputContainer>
            <TextInput
              value={nonCtgStudyId}
              // width="40px"
              // size="sm"
              placeholder="Enter Study ID"
              // labelText="Org Study ID"
              onKeyPress={(e) => e.key === 'Enter' && createStudyNonCTG()}
              onChange={e => onChangeInputNonCtg(
                e.target.value
              )} />
              </TextInputContainer>
            <Button
              kind="primary"
              // onClick={() => searchStudy()}
              onClick={() => createStudyNonCTG()}
              style={addBtnStyle}  
              disabled={nonCtgStudyId.length === 0}
            >Create Study</Button>
          </InputContainer>
        </div>
        <div style={{ marginBottom: "18px" }}>
          <ModalTitle>Create From CTG</ModalTitle>
          <InputContainer>
          <TextInputContainer>
          {/* { loadingStudies && <Loading /> } */}
            <TextInput
              value={org_study_id}
              placeholder="Enter Study ID"
              // labelText="Org Study ID"
              onKeyPress={(e) => e.key === 'Enter' && createStudyCTG()}
              onChange={e => onChangeInput(
                e.target.value
              )} />
              </TextInputContainer>
            <Button
              kind="primary"
              onClick={() => searchStudy()}
              style={addBtnStyle}  
            >Search Study
            </Button>

            <Button
              kind="primary"
              onClick={() => createStudyCTG()}
              disabled={selectedStudy ? false : true}
              style={addBtnStyle}  
            >Create Study</Button>
          </InputContainer>
          <Table size="lg" useZebraStyles={false} aria-label="sample table">
      <TableHead>
        <TableRow>
          {headers.map(header => <TableHeader id={header.key} key={header}>
              {header}
            </TableHeader>)}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(row => <TableRow key={row.id}>
            {Object.keys(row).map(key => {
              if(key !== 'id') return <TableCell key={key}>{row[key]}</TableCell>;
              else{
                return <TableCell>
                  { 
                    row['hasOwner'] === 'Yes' ? <i class="far fa-circle" style={{fontSize: '20px', cursor: 'not-allowed', color: '#D3D3D3'}} />
                    : selectedStudy === row[key] ? <i class="far fa-dot-circle" style={{fontSize: '20px', cursor: 'pointer'}} />
                    : <i class="far fa-circle"  style={{fontSize: '20px', cursor: 'pointer'}}
                      onClick={() => {setSelectedStudy(row[key])}}
                    />
                  }
                  
                </TableCell>
              }
        })}
          </TableRow>)}
      </TableBody>
    </Table>
        </div>

      </ModalContent>
    </MyModal>
  );
};

export default NewStudyModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
`
const ModalTitle = styled.div`
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #1f2733;
  letter-spacing: -.5px;
  padding-bottom: 10px;
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
`

const TextInputContainer = styled.div`
  width: 240px;
`